/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Norwegian (Bokmål)
export default {
  'editorExtensionLinkCreate.confluencePage.newDraftTitle': 'Side uten navn',
  'editorExtensionLinkCreate.confluencePage.quickInsert.description':
    'Opprett en ny side og sett den inn som en kobling',
  'editorExtensionLinkCreate.confluencePage.quickInsert.title': 'Opprett Confluence-side',
  'editorExtensionLinkCreate.confluencePage.successFlag.action.open': 'Åpne i Confluence',
  'editorExtensionLinkCreate.confluencePage.successFlag.description': 'Siden har blitt opprettet',
  'editorExtensionLinkCreate.confluencePage.successFlag.title': 'Siden er opprettet',
  'editorExtensionLinkCreate.confluencePage.title': 'Opprett ny side',
  'editorExtensionLinkCreate.genericError.description': 'Oppdater siden og prøv på nytt.',
  'editorExtensionLinkCreate.genericError.title': 'Det oppstod en feil',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.description':
    'Opprett en innebygd sak og sett inn saken som en kobling',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.title': 'Opprett Jira-sak',
  'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': 'Åpne i Jira',
  'editorExtensionLinkCreate.jiraIssue.successFlag.description': 'Saken har blitt opprettet',
  'editorExtensionLinkCreate.jiraIssue.successFlag.title': 'Saken er opprettet',
  'editorExtensionLinkCreate.jiraIssue.title': 'Opprett ny sak',
  'editorExtensionLinkCreate.keyword.create': 'opprett',
  'editorExtensionLinkCreate.keyword.issue': 'sak',
  'editorExtensionLinkCreate.keyword.new': 'ny',
  'editorExtensionLinkCreate.keyword.page': 'side',
  'editorExtensionLinkCreate.keyword.publish': 'publiser',
  'editorExtensionLinkCreate.keyword.raise': 'opprett',
  'editorExtensionLinkCreate.keyword.space': 'område',
  'editorExtensionLinkCreate.keyword.ticket': 'støtteforespørsel',
};
